<template>
  <div>
    <v-app-bar color="transparent" elevation="0" height="90px">
      <div class="container d-flex align-center position-relative">
        <img src="https://creditclan.com/images/logo-small.png" alt="cc logo" style="width: 130px"/>
        <v-spacer></v-spacer>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex">
          <router-link class="mr-6 grey--text text--darken-4" style="border-bottom: 2px solid #2e3c55" to="/">Home
          </router-link>
          <router-link class="mr-6 grey--text text--darken-4" to="/search">Search</router-link>
          <button @click="views.whatsapp = true" class="mr-6 grey--text text--darken-4">Whatsapp</button>
        </div>
      </div>
    </v-app-bar>

    <v-bottom-sheet v-if="$vuetify.breakpoint.smAndDown" inset max-width="500" scrollable v-model="views.whatsapp">
      <Whatsapp @close="views.whatsapp = false"/>
    </v-bottom-sheet>
    <v-navigation-drawer v-else fixed right temporary v-model="views.whatsapp" width="450">
      <Whatsapp @close="views.whatsapp = false"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Whatsapp from "@/components/nav/Whatsapp.vue";

export default {
  name: "DefaultDesktopNav",
  components: { Whatsapp },
  data: () => ({
    views: {
      whatsapp: false
    }
  })
}
</script>

